// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chemicals-page {
  padding: 1rem;
}
.chemicals-page h3 {
  margin-bottom: 1rem;
}
.chemicals-page .page-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
  gap: 0.75rem;
  flex-wrap: wrap;
}
.chemicals-page .page-toolbar h3 {
  margin-bottom: 0;
}
.chemicals-page .chemical-search {
  width: min(100%, 480px);
  height: 42px;
}
.chemicals-page .responsive-table {
  max-height: 68vh;
  overflow: auto;
  border-radius: 4px;
}
.chemicals-page table {
  width: 100%;
}
.chemicals-page .actions-cell {
  white-space: nowrap;
  width: 45px;
  padding-right: 0;
}
.chemicals-page th.mat-mdc-header-cell {
  font-weight: 600;
  background-color: #0066b2;
  color: #ffffff;
  position: sticky;
  top: 0;
  z-index: 2;
}
.chemicals-page th.mat-mdc-header-cell .mat-sort-header-arrow {
  color: #ffffff;
}
.chemicals-page td.mat-mdc-cell,
.chemicals-page th.mat-mdc-header-cell {
  padding: 0 12px;
}
.chemicals-page .col-edit, .chemicals-page .col-delete {
  width: 45px;
  min-width: 45px;
  max-width: 45px;
  padding-left: 4px !important;
  padding-right: 0 !important;
  white-space: nowrap;
}
.chemicals-page .col-number {
  width: 55px;
  min-width: 55px;
  max-width: 55px;
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/chemicals/chemicals.component.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAGA;EACI,aAAA;AAFJ;AAII;EACI,mBAAA;AAFR;AAKI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;AAHR;AAKQ;EACI,gBAAA;AAHZ;AAOI;EACI,uBAAA;EACA,YAAA;AALR;AAQI;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;AANR;AASI;EACI,WAAA;AAPR;AAUI;EACI,mBAAA;EACA,WAAA;EACA,gBAAA;AARR;AAWI;EACI,gBAAA;EACA,yBC7CM;ED8CN,cAAA;EACA,gBAAA;EACA,MAAA;EACA,UAAA;AATR;AAYI;EACI,cAAA;AAVR;AAaI;;EAEI,eAAA;AAXR;AAcI;EACI,WAAA;EACA,eAAA;EACA,eAAA;EACA,4BAAA;EACA,2BAAA;EACA,mBAAA;AAZR;AAeI;EACI,WAAA;EACA,eAAA;EACA,eAAA;EACA,mBAAA;AAbR","sourcesContent":["\n@use '../../../styles/colors' as colors;\n\n.chemicals-page {\n    padding: 1rem;\n\n    h3 {\n        margin-bottom: 1rem;\n    }\n\n    .page-toolbar {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        margin-bottom: 1rem;\n        gap: 0.75rem;\n        flex-wrap: wrap;\n\n        h3 {\n            margin-bottom: 0;\n        }\n    }\n\n    .chemical-search {\n        width: min(100%, 480px);\n        height: 42px;\n    }\n\n    .responsive-table {\n        max-height: 68vh;\n        overflow: auto;\n        border-radius: 4px;\n    }\n\n    table {\n        width: 100%;\n    }\n\n    .actions-cell {\n        white-space: nowrap;\n        width: 45px;\n        padding-right: 0;\n    }\n\n    th.mat-mdc-header-cell {\n        font-weight: 600;\n        background-color:  colors.$medium-blue;\n        color: #ffffff;\n        position: sticky;\n        top: 0;\n        z-index: 2;\n    }\n\n    th.mat-mdc-header-cell .mat-sort-header-arrow {\n        color: #ffffff;\n    }\n\n    td.mat-mdc-cell,\n    th.mat-mdc-header-cell {\n        padding: 0 12px;\n    }\n\n    .col-edit, .col-delete {\n        width: 45px;\n        min-width: 45px;\n        max-width: 45px;\n        padding-left: 4px !important;\n        padding-right: 0 !important;\n        white-space: nowrap;\n    }\n\n    .col-number {\n        width: 55px;\n        min-width: 55px;\n        max-width: 55px;\n        white-space: nowrap;\n    }\n}\n","$dark-blue: #0b2d71;\n$medium-blue: #0066b2;\n$light-blue: #009dd9;\n$dark-teal: #003653;\n$medium-teal: #00708c;\n$light-teal: #00b2bd;\n$dark-green: #444b0d;\n$medium-green: #769231;\n$light-green: #b2cc34;\n$dark-orange: #711b00;\n$medium-orange: #e5601f;\n$light-orange: #faab18;\n$dark-red: #58001c;\n$medium-red: #97002e;\n$light-red: #e21836;\n$lighter-red: rgb(247, 235, 239);\n$dark-purple: #3a0d36;\n$medium-purple: #751269;\n$light-purple: #ba3093;\n\n$dark-gray: #6b6d6f;\n$medium-gray: #8c8f93;\n$light-gray: #dbdcdd;\n$lighter-gray: #ECECEC;\n$lightest-gray: #f7f7f7; //alternative background-gray\n$lightest-gray2: #f3f3f3;\n\n$black: #000000;\n$white: #ffffff;\n$background-gray: #ededee;\n\n$highlight-blue: #E4F4FA; // for table highlights only\n$lighter-blue: #E4ECF2;\n$primary-blue: #007bff;\n$highlight-yellow: #E3F1A2;\n$highlight-peach: #FFE594;\n$highlight-neon: #FFA4C0;\n$success: #00708c;\n$warning: #faab18;\n$error: #97002e;"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
